import { render, staticRenderFns } from "./TaskPrioritySelect.vue?vue&type=template&id=135fcdd4&"
import script from "./TaskPrioritySelect.vue?vue&type=script&lang=js&"
export * from "./TaskPrioritySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports